export enum CookieType {
	source = 'source',
}
